import React, { useState, useEffect, useCallback } from "react";

import { Table, Space, Button, Popconfirm, Row, Badge } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { SearchColumn } from "../../../../components/SearchColumn/SearchColumn";

import { ModalAdd } from "./components/ModalAdd";
import { openNotification } from "../../../../components/Notification";
import { classificacaoAtributoService } from "../../../../services/resources/classificacaoAtributoService";

export const ListClassificacaoAtributo = () => {
  const [classificacaoAtributos, setClassificacaoAtributos] = useState([]);

  const [openModalAgravante, setOpenModalAgravante] = useState(false);

  const [codigo, setCodigo] = useState(null);
  const [codigoDelete, setCodigoDelete] = useState(null);
  const [mode, setMode] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    getGenero();
    // eslint-disable-next-line
  }, []);

  async function getGenero() {
    try {
      const { data } = await classificacaoAtributoService.loadClassificacoes();
      transformList(data);
    } catch (error) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar os sexos!</strong>,
        error?.response?.data?.detail
      );
    }
  }

  async function handleDelete(codigo) {
    setConfirmLoading(true);
    setDisabled(true);
    try {
      await classificacaoAtributoService.delete(codigo);
      openNotification("success", <strong>Classificação excluída com sucesso!</strong>);
      getGenero();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir a classificação!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setCodigoDelete(null);
      setConfirmLoading(false);
      setDisabled(false);
    }
  }

  const handleOpenModalAdd = useCallback((genero) => {
    setOpenModalAgravante(true);
    setCodigo(genero?.codigo);
  }, []);

  const handleCloseModalAdd = useCallback(() => {
    setOpenModalAgravante(false);
  }, []);

  const transformList = useCallback((list) => {
    list.sort(function (a, b) {
      return a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0;
    });
    setClassificacaoAtributos(list);
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        ...SearchColumn("descricao"),
      },
      {
        title: <strong>impedimento para finalizar denúncia</strong>,
        dataIndex: "impedeFechamentoDenuncia",
        key: "impedeFechamentoDenuncia",
        ...SearchColumn("impedeFechamentoDenuncia"),
        render: (impedeFechamentoDenuncia =>
          <Badge
            style={{
              backgroundColor:
                impedeFechamentoDenuncia
                  ? "var(--red-color)"
                  : "var(--green-color)",
              fontWeight: "bold",
            }}
            count={impedeFechamentoDenuncia ? "Impede" : "Não impede"}
          />
        ),
      },
      {
        title: <strong>necessidade de justificativas</strong>,
        dataIndex: "justificativaObrigatoria",
        key: "justificativaObrigatoria",
        ...SearchColumn("justificativaObrigatoria"),
        render: (justificativaObrigatoria =>
          <Badge
            style={{
              backgroundColor:
              justificativaObrigatoria
                  ? "var(--red-color)"
                  : "var(--green-color)",
              fontWeight: "bold",
            }}
            count={justificativaObrigatoria ? "Necessita" : "Não necessita"}
          />

        )
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: (genero) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              ghost
              title={`Visualizar classificação procedência ${genero?.descricao}`}
              onClick={() => {
                handleOpenModalAdd(genero);
                setMode("onView");
              }}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              type="primary"
              className="action-button"
              title={`Editar classificação procedência ${genero?.descricao}`}
              onClick={() => {
                handleOpenModalAdd(genero);
                setMode("onEdit");
              }}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir classificação de procedência <strong>{genero?.descricao}</strong>?"
                  </span>
                }
                visible={genero?.codigo === codigoDelete}
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDelete(genero?.codigo)}
                onCancel={() => setCodigoDelete(null)}
                okButtonProps={{ loading: confirmLoading }}
                disabled={disabled}
                cancelButtonProps={{ disabled: disabled }}
              >
                <Button
                  type="danger"
                  className="action-button"
                  title={`Excluir classificação de procedência ${genero?.descricao}`}
                  onClick={() => {
                    setCodigoDelete(genero?.codigo);
                  }}
                >
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> classificações
        </>
      );
    }
    return (
      <Table
        dataSource={classificacaoAtributos}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          size: "small",
          showSizeChanger: true,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <Row id="header">
          <h2>LISTA DE CLASSIFICAÇÕES DE PROCEDÊNCIA</h2>

          <Button
            type="primary"
            onClick={() => {
              handleOpenModalAdd(null);
              setMode("onCreate");
            }}
          >
            nova classificacão
          </Button>
        </Row>
        {renderTable()}
      </div>

      {openModalAgravante && (
        <ModalAdd
          onClose={handleCloseModalAdd}
          codigo={codigo}
          mode={mode}
          reload={getGenero}
        />
      )}
    </>
  );
};
